<template>
  <div class="patent-body  w">


    <!-- 知识产权的列表信息 -->
    <div class="patent-card">
      <el-row style="margin-left: -10px;margin-right: -10px;" >
        <div class="item-card" v-for="patent in patentList">
          <el-col :span="6"  >

            <router-link :to="'/patentDetail/'+patent.id" target="_blank">
              <el-card :body-style="{ padding: '0px' }">
                <!-- onerror 暂时没有更好的办法，写死链接即可。-->
                <block v-if="patent.yyptPicUrl!=undefined  && patent.yyptPicUrl!='' ">
                  <!--                  <img :src='`${patent.yyptPicUrl}`' alt="">-->
                  <img :src='`${domain}${patent.yyptPicUrl}`' alt="" class="image">
                </block>
                <block v-else>
                  <img v-if="patent.patentType=='软件著作权'"
                       src="../../assets/images/ruanzhu.jpg"
                       class="image"/>
                  <img v-else
                       src="../../assets/images/zhuanli.png"
                       class="image"/>
                </block>
                <div class="remarks ellipsis" style="padding: 14px">
                  <el-tooltip
                      class="box-item"
                      effect="dark"
                      :content="patent.name"
                      placement="top-start">
                    <span class="name">{{ patent.name }}</span>
                  </el-tooltip>
                  <div class="bottom">
                    <span>授权号:{{ patent.grantNo }}</span>
                    <span>{{ patent.userFirst }}</span>
                  </div>
                </div>
              </el-card>
            </router-link>
          </el-col>
        </div>


      </el-row>
    </div>


    <!--分页-->
    <div class="pagination">
      <el-pagination
          :page-size="pageSize"
          :pager-count="10"
          background
          layout="prev, pager, next"
          :total="totalNum"
          :hide-on-single-page="totalNum<=0"
          v-model:current-page="currentPage"
          @current-change="handelCurrentChange"
      />
    </div>

  </div>

</template>


<script>
import {reactive, ref} from 'vue'
import {getPatentType, getPatentList} from '@/api/Patent.js'
import {toRaw} from '@vue/reactivity'
import { useRoute } from 'vue-router';


export default {
  setup(props) {
    const domain = ref(process.env.VUE_APP_DOMAIN)

    // 表单赋值
    const form = reactive({
      patentType: [],
      grantNo: '',
      name: '',
      keywords: '',
      inventor: '',
      classifyNo: ''  // 分类号
    })

    return {form,domain};
  },
  data() {
    return {
      patentTypeList: [],
      patentList: [],  // 当前显示的知识产权内容
      pageNo: 1,  // 当前页面
      pageSize: 8,  // 每页显示8个
      totalNum: 1000,  // 一共多少条记录
      currentPage: 1, // 当前页
    }
  },
  mounted() {
    const route = useRoute();
    const name = route.query.name;  // 接收传递的参数
    if(name!=''){
      this.form.name  = name ;
    }

    this.getPatentType();
    this.search(0);


  },

  methods: {
    // 获取知识产权类型的字典值
    async getPatentType() {
      let params = {
        dictType: "patent_type"
      };
      await getPatentType(params).then(({data}) => {
        // data.forEach((item)=>{
        //   this.patentTypeList.push(item.value)
        // })
        console.log('获取知识产权类型的字典值：', data)
        this.patentTypeList = data
      });
    },


    // 查询
    async search(pageNo) {
      // toRaw的解释  https://blog.csdn.net/qq_36595944/article/details/123853965
      let params = toRaw(this.form);
      params.pageSize = 8;
      params.pageNo = pageNo;
      params.orderBy = "grant_no desc";
      let result = await getPatentList(params);
      console.log("查询结果：", result)
      this.patentList = result.rows
      this.totalNum = result.total
    },
    resetSearch() {

      this.$refs.form1.resetFields()
      this.search()
    },

    handelCurrentChange(value) {
      console.log("选中的页码：",value)
      this.search(value)
    },

    imgOnError(e){
      //  onerror="this.src='http://localhost:8081/patent/userfiles/1/%E7%A8%8B%E5%BA%8F%E9%99%84%E4%BB%B6//cms/display/carousel/2022/11/defaultImg.jpg'"
      let img = e.srcElement;
      img.src = this.domain+'/patent/userfiles/1/%E7%A8%8B%E5%BA%8F%E9%99%84%E4%BB%B6//cms/display/carousel/2022/11/defaultImg.jpg';
      img.onerror = null; //防止闪图
    },

    patentDetail(params) {
      let id = params.id;
      console.log(id)
      let routerdata = this.$router.push({
        name: "/patentDetail", //此name就是基金对比页面path的name,在router里边配好的该页面的名字，这样直接就可以匹配到该页面的路径

      });

      window.open(routerdata, "_blank");
    },
  }
};
</script>

<style lang="less" scoped>

.patent-body {
  //padding: 20px;



  .patent-card {
    margin-top: 20px;
    .item-card{
      width: 305px;
      padding: 0 10px;
      box-sizing: border-box;
    }
    .image{
      width: 253px;
      height: 170px;

      padding: 15px;
    }
    .remarks {
      box-sizing: border-box;
      width: 283px;
      overflow: hidden;
      .name {
        font-size: 16px;
        font-weight: 600;
      }
      .bottom {
        margin-top: 5px;
        display: flex;
        flex-direction: column;
        span {
          display: inline-block;
          margin: 5px 0 5px 0;
        }
      }
    }
  }

}

.el-card {
  margin: 15px 0;
  width: 283px;
}

.el-pagination {
  margin-top: 10px;
  justify-content: center; //居中
}

</style>